module.exports = __webpack_public_path__ + "static/media/GreyBorderStar.1ca28ddf.svg";